<template>
	<div v-if="deviceForm" class="py-8">
		<Card>
			<template #content>
				<DevicePropertiesForm
            :form="deviceForm"
            @on-save="saveDevice"
            @on-delete="confirmDelete"
			@on-recover="confirmRecover"
			@on-duplicate="openDuplicateDialog"
			:is-deleted="deviceForm.is_deleted"
            :disabled="!$auth.hasPermission('update:devices')"
        />
			</template>
		</Card>
		<DeviceDuplicateDialog ref="duplicateDialog" @on-duplicated="onDuplicated" />
	</div>
</template>

<script>
import DevicePropertiesForm from "@/Forms/Device/DevicePropertiesForm.vue";
import DeviceDuplicateDialog from "@/Dialogs/DeviceDuplicateDialog.vue";
import { mapStores } from "pinia";
import { useDevicesStore } from "@/stores/devices.js";

export default {
	name: "DevicePropertiesView",
	components: {DevicePropertiesForm, DeviceDuplicateDialog},
	data() {
		return {
			deviceForm: undefined,
		}
	},
	emits: [
		'on-save',
		'on-delete',
		'on-recover',
	],
	computed: {
		...mapStores(useDevicesStore)
	},
	methods: {
		async saveDevice() {
			try {
				const response = await this.deviceForm.submit();
        this.$toast.add({
          severity: 'success',
          summary: this.$t('common.complete'),
          detail: this.$t('pages.admin.devices.devices.device.properties.device_properties_view.device_saved'),
          life: 3000
        });
        this.$emit('on-save');
				this.$router.replace({ params: {...this.$route.params, device: response.data.id} });
			} catch (error) {
				//
			}
		},
		confirmDelete(){
			this.$confirm.require({
				group: 'delete',
				message: this.$t('pages.admin.devices.devices.device.properties.device_properties_view.are_you_sure_you_want_to_delete_this_device'),
				header: this.$t('pages.admin.devices.devices.device.properties.device_properties_view.delete_device'),
				accept: () => {
					this.deleteDevice();
				},
				reject: () => {
					this.$toast.add({
            severity: 'info',
            summary: this.$t('common.cancelled'),
            detail: this.$t('pages.admin.devices.devices.device.properties.device_properties_view.device_was_not_deleted'),
            life: 3000
          });
				}
			});
		},
		async deleteDevice() {
			try {
				if (this.$route.params.type !== 'NEW') {
				await this.devicesStore.deleteDevice(this.$route.params.device);
				this.$emit('on-delete');
				}
				this.$router.push({name: 'admin.devices', params: {...this.$route.params, device: undefined}});
			} catch (error) {
				//
			}
		},
		confirmRecover() {
			this.$confirm.require({
				group: 'confirm',
				message: this.$t('pages.admin.devices.devices.device.properties.device_properties_view.are_you_sure_you_want_to_recover_this_device'),
				header: this.$t('pages.admin.devices.devices.device.properties.device_properties_view.recover_device'),
				accept: () => {
					this.recoverDevice();
				},
				reject: () => {
					this.$toast.add({
						severity: 'info',
						summary: this.$t('common.cancelled'),
						detail: this.$t('pages.admin.devices.devices.device.properties.device_properties_view.device_was_not_recovered'),
						life: 3000
					});
				}
			});
		},
		async recoverDevice() {
			try {
				const deviceId = this.deviceForm?.id || this.$route.params.device;

				await this.devicesStore.recoverDevice(deviceId);
				// Reload the device form to reflect the restored state
				this.deviceForm = await this.devicesStore.editDevice(deviceId);
				this.$emit('on-save');
				
			} catch (error) {
				//
			}
		},
		openDuplicateDialog() {
			this.$refs.duplicateDialog.open(this.$route.params.device, this.deviceForm?.company_id);
		},
		onDuplicated(newDevice) {
			this.$emit('on-save');
			this.$router.push({ name: 'admin.devices.device', params: { device: newDevice.id } });
		},
	},
	watch: {
		'$route.params.device': {
			async handler(newValue, oldValue) {
				if(newValue){
					if(this.$route.params.device === 'NEW'){
						this.deviceForm = await this.devicesStore.createDevice();
					} else {
						this.deviceForm = await this.devicesStore.editDevice(this.$route.params.device);
						this.deviceForm.id = this.$route.params.device;
					}
				} else {
					this.deviceForm = undefined;
				}
			},
			immediate: true,
		}
	},
}
</script>
